// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-card[data-v-f2a9de32] {\n  width: 60vw;\n  min-width: 800px;\n}\n", ""]);
// Exports
module.exports = exports;
